import type { StoredArtifactReference } from '../artifactReference';

export interface Clip {
  // Starting time of the track item in the sequence (in ms)
  start: number;

  // End time of the track item in the sequence (in ms)
  end: number;

  /**
   * This should ideally be derivable as (end - start). But we still record it since Premiere reports
   * all 3 props. TODO: consider removing this.
   */
  duration?: number;

  /**
   * Start and end times relative to the source clip (in ms), as reported on the track item
   * object by Premiere. These represent the times after Premiere has applied speed
   * and reversal on the clip, and it can also be different depending on whether the track
   * item is created from a regular clip/subclip (then times are relative to the original media
   * duration), or a subclip that has restricted trims (then times are relative to the subclip
   * duration).
   */
  inPointPremiere?: number;
  outPointPremiere?: number;

  /**
   * Our interpretation of inPointPremiere and outPointPremiere (in ms).
   * Our code (in source copy operations and for downloading required segments for rendering
   * segmented highres) depends on inPoint and outPoint being relative to the full source media
   * duration, and without any speed/reversal applied. Currently at the time of export, we can
   * correctly calculate these when speed is applied, but we cannot do so when clip is reversed
   * (because that would require us to get the correct duration of the source media, which is not
   * trivial).
   */
  inPoint: number;
  outPoint: number;

  /**
   * Default is 1. Double speed is 2. Half speed is 0.5. Etc.
   */
  speed?: number;

  /**
   * Whether the clip is supposed to play backwards
   */
  isSpeedReversed?: boolean;


  mimirItemId?: string;
  startOffsetMasterClip?: number;
  mediaPath?: string;
  nodeId?: string;
  key?: string;

  // Carry artifact refs needed for segmented media
  artifact?: StoredArtifactReference;
}


function convertBackslashes(str: string | undefined): string {
  if (!str) {
    return '';
  }

  return str.replace(/\\/g, '/');
}

export function getClipKey(nodeId: string, projectPath: string): string {
  return convertBackslashes(projectPath) + '|' + nodeId;
}

export function getSequenceKey(sequenceId: string, projectPath: string): string {
  return sequenceId + '|' + convertBackslashes(projectPath);
}
export interface MimirClipDetails {
  mimirItemId: string;
  timeInClip: number;
  mimirArtifact?: StoredArtifactReference;
  isSpeedReversed?: boolean;
}

export interface MimirClipTiming {
  mimirItemId: string;
  inPoint: number;
  outPoint: number;
  mimirArtifact?: StoredArtifactReference;
}